import { Fragment } from 'react';
import Card from './Card';
import { useWallet } from '../../../wallet/walletContext';
import { ISubModalState } from '.';
import Text from '../../../atoms/Text';
import {
  SetLastConnectedWallet,
  WalletsType,
} from '../../ConnectedWallet/wallets.ls';

const ENABLE_POPUP_TEXT = 'Please allow popup window in your browser';

interface ISubWalletsModalProps extends ISubModalState {
  onCancel: () => void;
  onBack: () => void;
}

const SubWalletsModal = ({
  wallets,
  connector,
  onCancel,
  onBack,
}: ISubWalletsModalProps) => {
  const { onConnect } = useWallet();

  const handleConnect = (id: string) => {
    connector.options.setCurrentWallet(id);
    SetLastConnectedWallet(connector.id as WalletsType);
    onConnect(connector, onCancel);
  };

  return (
    <div className='connect_modal__contents'>
      <div className='connect_modal__contents__back_btn' onClick={onBack}>
        <div className='connect_modal__contents__back_btn__icon icon-chevron-left' />
        <Text size={16}>Back</Text>
      </div>
      {wallets.map((wallet) => (
        <Card
          key={wallet.id}
          title={wallet.title}
          icon={wallet.image}
          additionalClass='rounded-icon'
          popupWarning={wallet.isLink}
          onClick={() => handleConnect(wallet.id)}
        />
      ))}
    </div>
  );
};

export default SubWalletsModal;
